import { cn } from "@/libs/utils";
import { Box, CircularProgress, SxProps, Theme } from "@mui/material";
import React from "react";

interface LoaderProps {
  sx?: SxProps<Theme>;
  className?: string;
}

export const Loader: React.FC<LoaderProps> = ({ sx, className }) => (
  <Box
    className={cn("flex flex-wrap items-center justify-center w-full h-screen", className)}
    sx={sx}
    data-testid="loader"
  >
    <CircularProgress />
  </Box>
);
